import {
	SET_MESSAGE_VALUE
} from "../actions/chatCase/form";
import { CLEAR_LIST_MESSAGES, SAVE_MESSAGES, SET_ID_CASE } from "../actions/chatCase/messages";
import { CLEAR_LIST_DOCUMENTS, SAVE_DOCUMENTS, TOGGLE_SIDE_BAR } from "../actions/chatCase/document";
import { SET_SHOW_PAP } from "../actions/chatCase/pap";

export const initialState = {
	messageValue: {
		"message": "",
		"idCase": ""
	},
	messages: [],
	idCase: "",
	documents: [],
	showPap: false,
	showSideBar: false,
};

const comparer = (otherArray) => {
	return (current) => {
		return otherArray.filter((other) => {
			return other.id == current.id;
		}).length == 0;
	};
};

const chatCase = (state = initialState, action = {}) => {
	switch (action.type) {
	// Sauvegarde la valeur de l'input messag
	case SET_MESSAGE_VALUE : {
		return {
			...state,
			messageValue: {
				"message" : action.value,
				"idCase" : action.idCase
			}
		};
	}
	case SET_ID_CASE : {
		return {
			...state,
			idCase: action.idCase
		};
	}
	// Sauvegarde des messages
	case SAVE_MESSAGES : {

		// Ici on compare les messages déjà présent dans le store et les messages passé en argument de la fonction
		// saveMessages (action.messages)
		let onlyInB = action.messages.filter(comparer(state.messages));

		const newListMessages = [...state.messages];
		// Dans newListMessages, on reprend les messages du state et on y push le résultat de la comparaison
		// Dans onlyInB, on trouve les messages qui n'existe pas encore dans le state messages et que l'on veut intégrer
		// dans celui-ci
		newListMessages.push(onlyInB);
		// On aplatit le tableau d'un niveau
		const flatMessageList = newListMessages.flat();
		return {
			...state,
			messages: flatMessageList
		};
	}
	// Sauvegarde des tous les documents lié au user
	case SAVE_DOCUMENTS : {
		return {
			...state,
			documents: action.documents
		};
	}
	// Reset de la list des messages
	case CLEAR_LIST_MESSAGES : {
		return {
			...state,
			messages: []
		};
	}
	// Reset de la liste des documents
	case CLEAR_LIST_DOCUMENTS : {
		return {
			...state,
			documents: []
		};
	}
	// Affiche/Masque le PAP dans les messages
	case SET_SHOW_PAP : {
		return {
			...state,
			showPap: action.bool
		};
	}
	// Affiche/Massque la sidebar de la messagerie
	case TOGGLE_SIDE_BAR : {
		return {
			...state,
			showSideBar: action.bool
		};
	}
	default:
		return state;
	}
};

export default chatCase;